module.exports = __webpack_public_path__ + "static/media/hero.fb4f77d2.jpg";